import { Loader2 } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Label } from "../ui/label";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";

export default function CompetitorFormDialog({
  open,
  onOpenChange,
  darkMode,
  selectedCompetitor,
  formData,
  setFormData,
  saving,
  handleSave,
  socialPlatforms,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className={`max-w-lg ${darkMode ? "bg-[#161b22] border-[#30363d] text-white" : ""}`}
        data-testid="competitor-dialog"
      >
        <DialogHeader>
          <DialogTitle>{selectedCompetitor ? "Edit Competitor" : "Add Competitor"}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div>
            <Label className={darkMode ? "text-gray-300" : ""}>Company Name *</Label>
            <Input
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              className={`mt-1.5 ${darkMode ? "bg-[#21262d] border-[#30363d] text-white" : ""}`}
              data-testid="input-name"
            />
          </div>
          <div>
            <Label className={darkMode ? "text-gray-300" : ""}>Website URL</Label>
            <Input
              value={formData.website_url}
              onChange={(e) => setFormData({ ...formData, website_url: e.target.value })}
              className={`mt-1.5 ${darkMode ? "bg-[#21262d] border-[#30363d] text-white" : ""}`}
              data-testid="input-website"
            />
          </div>
          <div>
            <Label className={darkMode ? "text-gray-300" : ""}>Description</Label>
            <Textarea
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              rows={2}
              className={`mt-1.5 ${darkMode ? "bg-[#21262d] border-[#30363d] text-white" : ""}`}
              data-testid="input-description"
            />
          </div>
          <div className="grid grid-cols-2 gap-3">
            {socialPlatforms.map((p) => (
              <div key={p.key}>
                <Label className={`text-sm ${darkMode ? "text-gray-400" : "text-gray-500"}`}>
                  {p.label}
                </Label>
                <Input
                  value={formData[p.key]}
                  onChange={(e) => setFormData({ ...formData, [p.key]: e.target.value })}
                  className={`mt-1 text-sm ${darkMode ? "bg-[#21262d] border-[#30363d] text-white" : ""}`}
                  data-testid={`input-${p.key}`}
                />
              </div>
            ))}
          </div>
        </div>
        <DialogFooter>
          <Button
            variant="ghost"
            onClick={() => onOpenChange(false)}
            className={darkMode ? "text-gray-400" : ""}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            disabled={saving}
            className="bg-[#DC143C] hover:bg-[#b91031] text-white"
            data-testid="save-competitor-btn"
          >
            {saving ? (
              <Loader2 className="w-4 h-4 animate-spin" />
            ) : selectedCompetitor ? (
              "Update"
            ) : (
              "Add"
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
